import { FC, ReactNode, useRef } from 'react';
import useOverflowDetection from 'src/common/hooks/useOverflowDetection';
import TripCartPanelTitle, { TripCartDrawerTitleProps } from 'src/trip-cart-deprecated/components/panel/TripCartPanelTitle';
import { Prettify } from 'src/common/types';
import styles from './TripCartPanelContent.module.scss';

type TripCartDrawerContentProps = Prettify<{
  children: ReactNode;
} & Omit<TripCartDrawerTitleProps, 'border'>>;

const TripCartPanelContent: FC<TripCartDrawerContentProps> = ({
  title,
  subtitle,
  showClose,
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const canScroll = useOverflowDetection({ ref });
  return (
    <div className={styles.root} ref={ref}>
      <TripCartPanelTitle
        title={title}
        subtitle={subtitle}
        border={canScroll}
        showClose={showClose}
      />
      {children}
    </div>
  );
};

export default TripCartPanelContent;
